import { MyHttpClient } from '../../../app/http-client.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "../../http-client.service";
var CaptainFraudOrdersService = /** @class */ (function () {
    function CaptainFraudOrdersService(http) {
        this.http = http;
        this.server = "" + environment.server;
        this.fraudOrdersUrl = this.server + '/api/fraudEngine/fraudOrders';
        this.fetchOrderUrl = this.server + '/api/orders/fetch';
    }
    CaptainFraudOrdersService.prototype.getFraudOrders = function (body) {
        return this.http.post(this.fraudOrdersUrl, body).pipe(catchError(this.handleError));
    };
    CaptainFraudOrdersService.prototype.handleError = function (error) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error("Backend returned code " + error.status + ", " +
                ("body was: " + error.error));
        }
        // return an observable with a user-facing error message
        return throwError(error);
    };
    CaptainFraudOrdersService.ngInjectableDef = i0.defineInjectable({ factory: function CaptainFraudOrdersService_Factory() { return new CaptainFraudOrdersService(i0.inject(i1.MyHttpClient)); }, token: CaptainFraudOrdersService, providedIn: "root" });
    return CaptainFraudOrdersService;
}());
export { CaptainFraudOrdersService };
